const ProgressiveContractLoader = ({ contractTitle, progress, progressMessage, error }) => {
  const clampedProgress = Math.max(0, Math.min(100, progress || 0));

  return (
    <div className="flex flex-col items-center justify-center h-full gap-4 p-4">
      <div className="w-full max-w-xs space-y-3">
        <p className="text-sm font-semibold text-primary text-center truncate">
          {contractTitle || "Contract"}
        </p>

        <div className="w-full bg-surface-active rounded-full h-2 overflow-hidden">
          <div
            className="bg-primary h-full rounded-full transition-all duration-500 ease-out"
            style={{ width: `${clampedProgress}%` }}
          />
        </div>

        <div className="flex items-center justify-between text-xs text-mediumgrey">
          <span className="truncate">
            {progressMessage || "Preparing..."}
          </span>
          <span className="shrink-0 ml-2">{clampedProgress}%</span>
        </div>
      </div>

      {error && (
        <p className="text-xs text-danger text-center max-w-xs">{error}</p>
      )}
    </div>
  );
};

export default ProgressiveContractLoader;
